export default __webpack_public_path__ + "media/images/logo_transparent-27d047319655fe7429c4c1279deb4800.svg";